/* eslint-disable @typescript-eslint/no-non-null-assertion */
import {getUserData} from '@common'
import {UserRole} from '@enums'
import {getUserSelectionAtom} from '@state'

import {useQuery} from '@tanstack/react-query'
import {getDefaultStore} from 'jotai'

import {CompanyResponse} from '../company/types'
import {getAllParentCompanies, getParentCompanyById, getLinkedCompanies} from './api'
import {parentCompanyKeys} from './keys'
import {ParentCompanyResponse} from './types'

export const useParentCompanies = (id?: string) => {
  return useQuery<ParentCompanyResponse[], unknown>({
    queryKey: parentCompanyKeys.list(),
    queryFn: async () => {
      const currentUser = getUserData()
      const userSelectionMap = getDefaultStore().get(getUserSelectionAtom)
      const userSelection = userSelectionMap[currentUser.id]

      switch (currentUser.role) {
        case UserRole.SUPER_ADMIN:
          return getAllParentCompanies()

        default: {
          const parentCompanyId = userSelection?.parentCompanyId ?? id
          if (!parentCompanyId) {
            return []
          }

          const parentCompany = await getParentCompanyById(parentCompanyId)

          return [parentCompany]
        }
      }
    },
  })
}

export const useParentCompany = (id?: string) => {
  return useQuery<ParentCompanyResponse, unknown>({
    queryKey: parentCompanyKeys.detail(id || ''),
    queryFn: () => getParentCompanyById(id!),
    enabled: !!id,
  })
}

export const useLinkedCompanies = (parentCompanyId?: string) => {
  return useQuery<CompanyResponse[], unknown>({
    queryKey: parentCompanyKeys.linkedCompanies(parentCompanyId || ''),
    queryFn: () => getLinkedCompanies(parentCompanyId!),
    enabled: !!parentCompanyId,
  })
}
